export const TOP_UP_LIST = 'TOP_UP_LIST'